import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function MoveToolIcon() {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="512.000000pt"
            height="512.000000pt"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
            className="svg-icon"
        >
            <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                stroke="none"
            >
                <path
                    d="M334 4844 c-21 -20 -25 -33 -22 -62 2 -20 376 -1067 832 -2327 859
-2378 842 -2335 896 -2335 54 0 55 2 418 1070 l349 1025 1048 286 c752 206
1053 292 1067 306 28 28 27 79 -3 108 -27 26 -4504 1955 -4538 1955 -12 0 -33
-11 -47 -26z"
                />
            </g>
        </svg>
    )
}
